export default {
  title: 'Het lijkt erop dat je offline bent',
  description:
    'Klik op “Pagina herladen” en/of controleer je internetverbinding om zeker te zijn dat je online bent 😊',
  custom_button: {
    reload: 'Pagina herladen',
  },
};
